import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  addRow(event) {
    const button = event.currentTarget
    const moduleKey = button.dataset.moduleKey
    const rowsContainer = this.element.querySelector(`[data-module-rows="${moduleKey}"]`)
    // Each module has its own template because the condition dropdown options
    // differ per module.
    const template = this.element.querySelector(`template[data-admin-conditions-template-for="${moduleKey}"]`)
    if (!rowsContainer || !template) {
      return
    }

    rowsContainer.insertAdjacentHTML("beforeend", template.innerHTML)
  }

  removeRow(event) {
    const row = event.currentTarget.closest("[data-admin-condition-row]")
    if (!row) {
      return
    }
    row.remove()
  }
}
